import {useEffect} from 'react';
import {Navigate, Route, Routes} from 'react-router';
import {BrowserRouter} from 'react-router-dom';

import LoginPage from 'pages/auth/login/Login';
import RegisterPage from 'pages/auth/register/Register';
import PlansPage from 'pages/plans/Plans';
import {AuthProvider} from 'contexts/AuthContext';
import useAuth from 'hooks/useAuth';
import Container from 'components/container/Container';
import {getServices} from './services';

const LogoutPage = () => {
  useEffect(() => {
    const {authService} = getServices();
    authService.logout();
  }, []);
  return (
    <Container>
      <p>Logging out...</p>
    </Container>
  );
};

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PlansPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

const Navigation = () => {
  const {user, isLoading} = useAuth();
  if (isLoading) {
    return (
      <Container>
        <p>Loading...</p>
      </Container>
    );
  }
  return !user ? <AuthRoutes /> : <AppRoutes />;
};

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navigation />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
